// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uUBwAz25K3USQG {
  margin-top: var(--ds-space-negative-150, -10px);
}
.OsrJ3G2RF0GuEI {
  margin-top: var(--ds-space-150, 10px);
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-semibold, 600);
}
.zeRPNEA2aojuwC {
  margin-left: var(--ds-space-025, 2px);
  color: var(--ds-text-danger, '#DE350B');
}
`, ""]);
// Exports
export var checkbox = `uUBwAz25K3USQG`;
export var label = `OsrJ3G2RF0GuEI`;
export var required = `zeRPNEA2aojuwC`;
export default ___CSS_LOADER_EXPORT___;
